module.exports = __webpack_public_path__ + "static/5-7097e391cd788917e863057c3d328f5a.jpg";